module.exports = __webpack_public_path__ + "img/icon-cities.8331449e.svg";